import {
  BaseAppError,
} from '@modules/core/errors';
import {
  MutationCache,
  QueryCache,
  QueryClient,
} from '@tanstack/vue-query';

let queryClient: QueryClient | undefined;

export default function getQueryClient(): QueryClient {
  if (!queryClient) {
    queryClient = new QueryClient({
      queryCache: new QueryCache({
        onError(error) {
          if (error instanceof BaseAppError && error.useGlobalHandler) {
            void Promise.reject(error);
          }
        },
      }),
      mutationCache: new MutationCache({
        onError(error) {
          if (error instanceof BaseAppError && error.useGlobalHandler) {
            void Promise.reject(error);
          }
        },
      }),
      defaultOptions: {
        queries: {
          staleTime: 1000,
          gcTime: 5 * 60 * 1000, // 5 min in cache by default
          refetchOnMount: true,
          refetchOnWindowFocus: false,
          refetchOnReconnect: false,
        },
      },
    });
  }

  return queryClient;
}
